import CMain from '../CMain';
import CPoint from '../cppComponents/CPoint';
import React from 'react';
import { View } from 'react-native';

class CMonopoly extends CMain {
    async LoadBitmaps() {}
    OnLButtonDblClk(point: CPoint) {
        console.log(point);
    }
    SendKoiENaRed() {}
    SendNames() {}
    OPL: boolean[] = [];
    InitOP(server: boolean) {
        console.log(server);
    }
    async OnLButtonDown(point: CPoint) {
        console.log('point', point);
    }
    async OnRButtonDown(point: CPoint) {
        console.log('point', point);
    }
    async ReceiveGame(strRecvd: string) {
        console.log(strRecvd);
        return true;
    }
    Timer7() {}
    Timer3() {}
    Timer2() {}
    constructor(props) {
        super(props);
    }
    Timer1() {}

    DrawView() {
        return null;
    }

    render() {
        if (this.props.m_pwin.game === 'Monopoly') {
            return <View key={'Monopoly'}>{this.DrawView()}</View>;
        } else {
            return null;
        }
    }
}

export default CMonopoly;
